import { ClientInfoState } from "shared/core/state/clientInfoState";
import { useGetSupportMomentsResourcesFunctionRequest, useGetUserTermsStatusFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { TermKeys } from "core/enums/enums";

export const useSupportMomentsAvailability = () => {
  const xClientCode = ClientInfoState?.getCode();

  const { data: resourcesData, isLoading: isLoadingResources, error: resourcesError } = useGetSupportMomentsResourcesFunctionRequest({ xClientCode });
  const {
    data: coachmarkStatus,
    isLoading: isLoadingCoachmarkStatus,
    error: statusError,
    mutate: mutateCoachmarkStatus,
  } = useGetUserTermsStatusFunctionRequest({ xClientCode, key: TermKeys.SupportMomentsTutorial });

  const isLoading = isLoadingResources || isLoadingCoachmarkStatus;
  const isAvailable = !isLoading && !resourcesError && !statusError && !!resourcesData?.feelings?.length;

  return {
    isLoading,
    isAvailable,
    resources: resourcesData?.feelings,
    coachmarkStatus,
    isLoadingCoachmarkStatus,
    mutateCoachmarkStatus,
  };
};
